import {
  Box,
  Table,
} from "@chakra-ui/react";

import { formatNumber } from "../../../store/helpers";
import LineGraph from "../../LineGraph";
import ReportDataTable from "../../reports/ReportDataTable";
import { ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const renderCell = (row, columnId) => {
  if (columnId === "scopeName") return row.scopeName || row.branchName;
  if (columnId === "total") return formatNumber(row.total);
  if (columnId === "average") return formatNumber(row.average);
  if (columnId === "min") return formatNumber(row.min);
  if (columnId === "max") return formatNumber(row.max);
  return null;
};

const ArrivalRatesPerDayTable = ({ data, index, renderConfig, onRenderConfigChange }) => {
  const { total, average, min, max, branchName, chart } = data;
  const row = { ...data, scopeName: branchName || "Entire Organization" };

  if (!renderConfig?.charts?.enabled) {
    return (
      <Box className="arrivalRatesSummaryBlock">
        <ReportDataTable
          columns={ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS}
          rows={[row]}
          renderConfig={renderConfig}
          renderCell={renderCell}
          onSortChange={(sort) => onRenderConfigChange?.({ ...renderConfig, sort })}
        />
      </Box>
    );
  }

  return (
    <>
      <Box>
        <Table.Root className="stripedTable" size="sm">
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>#</Table.ColumnHeader>
              <Table.ColumnHeader>Total Visitors</Table.ColumnHeader>
              <Table.ColumnHeader>Average</Table.ColumnHeader>
              <Table.ColumnHeader>Min</Table.ColumnHeader>
              <Table.ColumnHeader>Max</Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>{index + 1}</Table.Cell>
              <Table.Cell borderRight="1px solid #dadce0">{formatNumber(total)}</Table.Cell>
              <Table.Cell borderRight="1px solid #dadce0">{formatNumber(average)}</Table.Cell>
              <Table.Cell>{formatNumber(min)}</Table.Cell>
              <Table.Cell>{formatNumber(max)}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell colSpan={5}>
                <Box mt="20px" mb="20px">
                  <LineGraph
                    chart={chart}
                    title={`${branchName} Arrival rates per day, Day by Day Comparison`}
                  />
                </Box>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table.Root>
      </Box>
    </>
  );
};

export default ArrivalRatesPerDayTable;
